import { type MonitoringCycle } from "@/mocks/vistorias";

interface MonitoringCycleCardProps {
  cycles: MonitoringCycle[];
}

export default function MonitoringCycleCard({ cycles }: MonitoringCycleCardProps) {
  const statusConfig: Record<string, { badge: string; dot: string }> = {
    "Em andamento": { badge: "bg-primary-100 text-primary-700", dot: "bg-primary-500" },
    "Planejado": { badge: "bg-secondary-100 text-secondary-700", dot: "bg-secondary-400" },
    "Concluído": { badge: "bg-accent-100 text-accent-700", dot: "bg-accent-500" },
    "Pausado": { badge: "bg-warning-100 text-warning-700", dot: "bg-warning-500" },
  };

  return (
    <div className="bg-white rounded-xl border border-background-200/70 overflow-hidden">
      <div className="px-5 py-3.5 border-b border-background-100 flex items-center gap-2.5">
        <span className="w-8 h-8 rounded-lg bg-accent-50 flex items-center justify-center">
          <i className="ri-loop-left-line text-accent-500"></i>
        </span>
        <span className="text-sm font-semibold text-foreground-900 font-heading">Ciclos de Monitoramento</span>
      </div>
      <div className="divide-y divide-background-100">
        {cycles.map((ciclo) => {
          const sc = statusConfig[ciclo.status] || statusConfig["Planejado"];
          return (
            <div key={ciclo.id} className="px-5 py-4 hover:bg-background-50/60 transition-colors cursor-pointer">
              <div className="flex items-start justify-between gap-3 mb-2">
                <div className="flex items-center gap-2.5 min-w-0">
                  <div className={`w-2 h-2 rounded-full shrink-0 ${sc.dot}`}></div>
                  <h4 className="text-sm font-semibold text-foreground-900 truncate">{ciclo.nome}</h4>
                </div>
                <span className={`badge shrink-0 ${sc.badge}`}>{ciclo.status}</span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-3 ml-4.5">
                <div>
                  <span className="text-xs text-foreground-400">Tipo</span>
                  <p className="text-xs font-medium text-foreground-700">{ciclo.tipo}</p>
                </div>
                <div>
                  <span className="text-xs text-foreground-400">Período</span>
                  <p className="text-xs font-medium text-foreground-700">
                    {new Date(ciclo.dataInicio + "T00:00:00").toLocaleDateString("pt-BR", { month: "short", year: "numeric" })} —{" "}
                    {new Date(ciclo.dataFim + "T00:00:00").toLocaleDateString("pt-BR", { month: "short", year: "numeric" })}
                  </p>
                </div>
                <div>
                  <span className="text-xs text-foreground-400">Árvores</span>
                  <p className="text-xs font-medium text-foreground-700">
                    {ciclo.vistoriasRealizadas.toLocaleString("pt-BR")} / {ciclo.arvoresPrevistas.toLocaleString("pt-BR")}
                  </p>
                </div>
                <div>
                  <span className="text-xs text-foreground-400">Pendências</span>
                  <p className="text-xs font-medium text-warning-600">{ciclo.pendencias}</p>
                </div>
              </div>
              {/* Progress bar */}
              <div className="flex items-center gap-2">
                <div className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                  <div
                    className="h-full rounded-full bg-primary-500 transition-all duration-500"
                    style={{ width: `${ciclo.progresso}%` }}
                  ></div>
                </div>
                <span className="text-xs font-semibold text-foreground-600 w-9 text-right">{ciclo.progresso}%</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}